exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".disclaimer-c9a7e12f{font-size:10px;line-height:13px;color:#757575}.disclaimer-c9a7e12f a{color:#212121 !important}.title-f2fd2025{font-size:22px;line-height:28px;color:#2a2a2a;margin-bottom:10px;text-align:center;margin-top:30px}.subtitle-42a51631{font-size:14px;text-align:center;line-height:16px;color:#757575;padding-bottom:30px;border-bottom:1px solid #e8e8e8}.form-0b9e66a5{margin:30px}.SignupModal-7bf47223{display:flex}.left-2d23869c{padding:30px;background:#eceed9}.left-2d23869c .title-f2fd2025{margin-top:20px;margin-bottom:30px}.left-2d23869c,.right-3ceaf715{width:50%}@media (max-width: 889px){.left-2d23869c{display:none}.right-3ceaf715{width:100%}.SignupModal-7bf47223{display:block}}.logo-0727925c{text-align:center}.feature-7475e607{margin-top:30px;color:#2a2a2a}.feature-7475e607 svg{display:block;margin-bottom:10px}.featureTitle-a5aac054{font-weight:500;margin-bottom:5px;color:#282828}\n", ""]);

// Exports
exports.locals = {
	"disclaimer": "disclaimer-c9a7e12f",
	"title": "title-f2fd2025",
	"subtitle": "subtitle-42a51631",
	"form": "form-0b9e66a5",
	"SignupModal": "SignupModal-7bf47223",
	"left": "left-2d23869c",
	"right": "right-3ceaf715",
	"logo": "logo-0727925c",
	"feature": "feature-7475e607",
	"featureTitle": "featureTitle-a5aac054"
};